"use strict";

var _taggedTemplateLiteral = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _slicedToArray = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _optionalChain(ops) {
  var lastAccessLHS = undefined;
  var value = ops[0];
  var i = 1;

  while (i < ops.length) {
    var op = ops[i];
    var fn = ops[i + 1];
    i += 2;

    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      return undefined;
    }

    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn(function () {
        var _value;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return (_value = value).call.apply(_value, [lastAccessLHS].concat(args));
      });
      lastAccessLHS = undefined;
    }
  }

  return value;
}

var _chunkPORA5UPQjs = require('./chunk-PORA5UPQ.js');

require('./chunk-575KBOSD.js');

require('./chunk-TPZR5EWL.js');

require('./chunk-JDO43VGY.js');

require('./chunk-FKBTJYRF.js');

require('./chunk-P4KLBECR.js');

var _chunkG6S7YYHOjs = require('./chunk-G6S7YYHO.js');

require('./chunk-YS2SRWUB.js');

require('./chunk-CEAA42VM.js');

require('./chunk-OX4QNVYY.js');

require('./chunk-NESC3UD7.js');

var _chunk6R5OOOHCjs = require('./chunk-6R5OOOHC.js');

require('./chunk-R4XHR6A7.js');

require('./chunk-OUWZ2PU5.js');

var _react = require('react');

var _styledcomponents = require('styled-components');

var _styledcomponents2 = _interopRequireDefault(_styledcomponents);

var _jsxruntime = require('react/jsx-runtime');

var j = function j(_ref) {
  var _ref$buttonAriaLabe = _ref["button-aria-label"],
      o = _ref$buttonAriaLabe === void 0 ? "Search button" : _ref$buttonAriaLabe,
      r = _ref.className,
      _ref$id = _ref.id,
      d = _ref$id === void 0 ? "search-input" : _ref$id,
      _ref$initialValue = _ref.initialValue,
      f = _ref$initialValue === void 0 ? "" : _ref$initialValue,
      _ref$inputAriaLabel = _ref["input-aria-label"],
      v = _ref$inputAriaLabel === void 0 ? "Search input" : _ref$inputAriaLabel,
      b = _ref.onClear,
      h = _ref.onSubmit,
      g = _ref.onTextChange,
      _ref$placeholder = _ref.placeholder,
      x = _ref$placeholder === void 0 ? "Search items and auction houses" : _ref$placeholder,
      _ref$small = _ref.small,
      t = _ref$small === void 0 ? !1 : _ref$small;

  var _react$useState$call = _react.useState.call(void 0, f),
      _react$useState$call2 = _slicedToArray(_react$useState$call, 2),
      a = _react$useState$call2[0],
      I = _react$useState$call2[1],
      l = _react.useCallback.call(void 0, function (n) {
    _optionalChain([g, 'optionalCall', function (_) {
      return _(n);
    }]), I(n);
  }, [g]),
      k = _react.useCallback.call(void 0, function (n) {
    l(n.currentTarget.value);
  }, [l]),
      y = _react.useCallback.call(void 0, function () {
    _optionalChain([b, 'optionalCall', function (_2) {
      return _2();
    }]), l("");
  }, [l, b]),
      H = _react.useCallback.call(void 0, function (n) {
    _optionalChain([h, 'optionalCall', function (_3) {
      return _3(a);
    }]), n.preventDefault();
  }, [h, a]);

  return _jsxruntime.jsxs.call(void 0, C, {
    $placeHolderShown: a === "",
    $small: t,
    className: r,
    onSubmit: H,
    children: [_jsxruntime.jsx.call(void 0, F, {
      $small: t,
      "aria-label": v,
      id: d,
      onChange: k,
      onClear: y,
      placeholder: x,
      value: a
    }), _jsxruntime.jsx.call(void 0, p, {
      $small: t,
      "aria-label": o,
      id: "".concat(d, "-button"),
      tabIndex: -1,
      type: "submit",
      children: t ? _jsxruntime.jsx.call(void 0, _chunkG6S7YYHOjs.a, {}) : _jsxruntime.jsx.call(void 0, _chunkG6S7YYHOjs.b, {})
    })]
  });
},
    p = exports.SearchInputButton = _styledcomponents2.default.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin: 0;\n    padding: 0;\n    border: none;\n    outline: none;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    align-self: center;\n    justify-self: center;\n    background-color: transparent;\n    color: ", ";\n    pointer-events: none;\n    user-select: none;\n    margin-top: -1px;\n    margin-right: -1px;\n\n    ", ";\n\n    ", "\n"])), function (_ref2) {
  var o = _ref2.theme;
  return o.color.icon.default;
}, _chunk6R5OOOHCjs.f.call(void 0, "background-color"), function (_ref3) {
  var o = _ref3.$small;
  return o ? _styledcomponents.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n                  width: 34px;\n                  height: 34px;\n              "]))) : _styledcomponents.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n                  width: 42px;\n                  height: 42px;\n              "])));
}),
    C = exports.SearchInputForm = _styledcomponents2.default.form(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    margin: 0;\n    padding: 0;\n    border: none;\n    display: grid;\n    border: 1px solid ", ";\n    background-color: ", ";\n\n    ", ";\n\n    ", "\n\n    :hover {\n        border-color: ", ";\n    }\n\n    :has(input:focus) {\n        border-color: ", ";\n    }\n\n    ", "\n"])), function (_ref4) {
  var o = _ref4.theme;
  return o.color.border.divider.default;
}, function (_ref5) {
  var o = _ref5.theme;
  return o.color.background.field.default;
}, _chunk6R5OOOHCjs.f.call(void 0, "border-color"), function (_ref6) {
  var o = _ref6.$small;
  return o ? _styledcomponents.css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n                  grid-template-columns: 1fr 34px;\n                  height: 34px;\n              "]))) : _styledcomponents.css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n                  grid-template-columns: 1fr 42px;\n                  height: 42px;\n              "])));
}, function (_ref7) {
  var o = _ref7.theme;
  return o.color.border.hover;
}, function (_ref8) {
  var o = _ref8.theme;
  return o.color.border.focused.default;
}, function (_ref9) {
  var o = _ref9.$placeHolderShown,
      r = _ref9.theme;
  return !o && _styledcomponents.css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n            :not(:has(input:focus)):hover ", " {\n                color: ", ";\n            }\n\n            ", " {\n                color: ", ";\n                background-color: ", ";\n                cursor: pointer;\n                pointer-events: auto;\n\n                :not(:active):hover {\n                    background-color: ", ";\n                }\n\n                :active {\n                    background-color: ", ";\n                }\n            }\n        "])), p, r.color.icon.hover, p, r.color.icon.inverse, r.button.primary.color.background, r.button.primary.hover.color.background, r.button.primary.pressed.color.background);
}),
    F = exports.SearchInputTextInput = _styledcomponents2.default.call(void 0, _chunkPORA5UPQjs.a)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    border: none;\n\n    ", "\n"])), function (_ref10) {
  var o = _ref10.$small;
  return o ? _styledcomponents.css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n                  height: 32px;\n              "]))) : _styledcomponents.css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n                  height: 40px;\n              "])));
});

exports.SearchInput = j;
exports.SearchInputButton = p;
exports.SearchInputForm = C;
exports.SearchInputTextInput = F;